module.exports = __webpack_public_path__ + "static/TownOfLight0-87d54c92f519a1c78ff0913cfff3d217.png";